export default {
    ufEmailInput: '/auth/login/input/email',
    ufPasswordInput: '/auth/login/input/password',
    ufLoginButton: '/auth/login/button/login',
    ufRegisterButton: '/auth/login/button/register',
    ufForgotPasswordButton: '/auth/login/button/forgotPassword',
    ufSignInMsButton: '/auth/login/button/signInWithMicrosoft',
};
